import * as React from "react";
import { motion } from "framer-motion";

const HUDOverlay: React.FC = () => {
  return (
    <div className="absolute inset-0 pointer-events-none z-[50] overflow-hidden pointer-events-none">
      {/* Scanline Animation */}
      <motion.div
        animate={{ 
          top: ['-10%', '110%'],
          opacity: [0, 0.5, 0]
        }}
        transition={{ 
          duration: 8, 
          repeat: Infinity, 
          ease: "linear" 
        }}
        className="absolute left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-primary-orange/20 to-transparent blur-[1px]"
      />

      {/* Technical Corners */}
      <div className="absolute top-6 left-6 w-12 h-12 border-t-2 border-l-2 border-primary-orange/40 rounded-tl-lg" />
      <div className="absolute top-6 right-6 w-12 h-12 border-t-2 border-r-2 border-primary-orange/40 rounded-tr-lg" />
      <div className="absolute bottom-6 left-6 w-12 h-12 border-b-2 border-l-2 border-primary-orange/40 rounded-bl-lg" />
      <div className="absolute bottom-6 right-6 w-12 h-12 border-b-2 border-r-2 border-primary-orange/40 rounded-br-lg" />

      {/* Grid Dust / Atmosphere */}
      <div className="absolute inset-0 opacity-[0.03]" 
           style={{ backgroundImage: "radial-gradient(circle, #fff 1px, transparent 1px)", backgroundSize: "40px 40px" }} />
    </div>
  );
};

export { HUDOverlay };
